import { useEffect, useRef, useState } from "react";
import "./index.scss";
export default function Input({
  label = "",
  type = "text",
  onInput = () => {},
}) {
  const input = useRef();
  const [focused, setFocused] = useState(false);
  useEffect(() => {
    input.current.classList.toggle("focused", focused);
  }, [focused]);
  return (
    <div
      ref={input}
      className="Input position-relative w-100 border-bottom border-dark"
    >
      <input
        className="w-100 h-100 px-3 border-0"
        type={type}
        onInput={onInput}
        placeholder={label}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
    </div>
  );
}
